/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";

/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  "MENU_CHANGE_HAS_SUB_ITEM_STATUS";
export const SIDEBAR_DATA_LOADED = "SIDEBAR_DATA_LOADED";

// Registration
export const REGISTRATION_LOADING = "REGISTRATION_LOADING";
export const REGISTRATION_SUCCESSFUL = "REGISTRATION_SUCCESSFUL";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const REGISTRATION_COMPLETED = "REGISTRATION_COMPLETED";
export const REGISTRATION_FAILED = "REGISTRATION_FAILED";

// Authentication
export const AUTH_LOADING = "AUTH_LOADING";
export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const AUTH_FAILED = "AUTH_FAILED";
export const LOGOUT = "LOGOUT";
export const OTP_VERIFIED = "OTP_VERIFIED";
export const OTP_FAIELD = "OTP_FAIELD";

export const OAUTH_REGISTER_SUCCESS = "OAUTH_REGISTER_SUCCESS";
export const OAUTH_REGISTER_FAILED = "OAUTH_REGISTER_FAILED";
export const OAUTH_REGISTER_RESET = "OAUTH_REGISTER_RESET";
export const OAUTH_DEVICE_CLEARED = "OAUTH_DEVICE_CLEARED";

// User
export const USER_LOADED = "USER_LOADED";
export const USER_EDITED = "USER_EDITED";
export const PASSWORD_CHANGED = "PASSWORD_CHANGED";
export const USER_FAILED = "USER_FAILED";

// Reset Password
export const RESETTING_PASSWORD = "RESETTING_PASSWORD";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const PASSWORD_RESET_FAILED = "PASSWORD_RESET_FAILED";

//Company
export const COMPANY_CREATED = "COMPANY_CREATED";
export const COMPANY_LOADING = "COMPANY_LOADING";
export const COMPANY_DETAILS = "COMPANY_DETAILS";
export const COMPANY_DELETED = "COMPANY_DELETED";
export const COMPANY_LOADED = "COMPANY_LOADED";
export const COMPANY_EDITED = "COMPANY_EDITED";
export const COMPANY_SEARCH = "COMPANY_SEARCH";
export const COMPANY_FAILED = "COMPANY_FAILED";

// Pipe
export const PIPE_LOADING = "PIPE_LOADING";
export const PIPE_LOADED = "PIPE_LOADED";
export const PIPE_DETAILS = "PIPE_DETAILS";
export const PIPE_EDITED = "PIPE_EDITED";
export const PIPE_CREATED = "PIPE_CREATED";
export const PIPE_DELETED = "PIPE_DELETED";
export const PIPE_SEARCHED = "PIPE_SEARCHED";
export const PIPE_FAILED = "PIPE_FAILED";
export const PIPE_EVENTS = "PIPE_EVENTS";

export const PIPEACTIVITY_LOADING = "PIPEACTIVITY_LOADING";
export const PIPEACTIVITY_LOADED = "PIPEACTIVITY_LOADED";
export const PIPEACTIVITY_FAILED = "PIPEACTIVITY_FAILED";

//MNO
export const MNO_LOADING = "MNO_LOADING";
export const MNO_LOADED = "MNO_LOADED";
export const MNO_DETAILS = "MNO_DETAILS";
export const MNO_EDITED = "MNO_EDITED";
export const MNO_CREATED = "MNO_CREATED";
export const MNO_DELETED = "MNO_DELETED";
export const MNO_SEARCHED = "MNO_SEARCHED";
export const MNO_SUB_FORM = "MNO_SUB_FORM";
export const MNO_FAILED = "MNO_FAILED";

//BLACKLIST
export const BLACKLIST_LOADING = "BLACKLIST_LOADING";
export const BLACKLIST_LOADED = "BLACKLIST_LOADED";
export const BLACKLIST_CREATED = "BLACKLIST_CREATED";
export const BLACKLIST_DELETED = "BLACKLIST_DELETED";
export const BLACKLIST_SEARCHED = "BLACKLIST_SEARCHED";
export const BLACKLIST_FAILED = "BLACKLIST_FAILED";

//ENDPOINTS
export const ENDPOINT_LOADING = "ENDPOINT_LOADING";
export const ENDPOINT_LOADED = "ENDPOINT_LOADED";
export const ENDPOINT_SEARCHED = "ENDPOINT_SEARCHED";
export const ENDPOINT_CREATED = "ENDPOINT_CREATED";
export const ENDPOINT_EDITED = "ENDPOINT_EDITED";
export const ENDPOINT_DELETED = "ENDPOINT_DELETED";
export const ENDPOINT_FAILED = "ENDPOINT_FAILED";

//COMMAND
export const COMMAND_LOADING = "COMMAND_LOADING";
export const COMMAND_LOADED = "COMMAND_LOADED";
export const EXECUTE_COMMAND = "EXECUTE_COMMAND";
export const COMMAND_FAILED = "COMMAND_FAILED";

//ROUTE PATHS
export const ROUTEPATH_LOADING = "ROUTEPATH_LOADING";
export const ROUTEPATH_LOADED = "ROUTEPATH_LOADED";
export const ROUTEPATH_SEARCHED = "ROUTEPATH_SEARCHED";
export const ROUTEPATH_CREATED = "ROUTEPATH_CREATED";
export const ROUTEPATH_EDITED = "ROUTEPATH_EDITED";
export const ROUTEPATH_DELETED = "ROUTEPATH_DELETED";
export const ROUTEPATH_FAILED = "ROUTEPATH_FAILED";

// USSD
export const SCREENAPP_LOADING = "SCREENAPP_LOADING";
export const SCREENAPP_LOADED = "SCREENAPP_LOADED";
export const SCREENAPP_CREATED = "SCREENAPP_CREATED";
export const SCREENAPP_SEARCHED = "SCREENAPP_SEARCHED";
export const SCREENAPP_DELETED = "SCREENAPP_DELETED";
export const SCREENAPP_EDIT = "SCREENAPP_EDIT";
export const SCREENAPP_DETAILS = "SCREENAPP_DETAILS";
export const SCREENAPP_FAILED = "SCREENAPP_FAILED";

export const SCREEN_LOADING = "SCREEN_LOADING";
export const SCREEN_LOADED = "SCREEN_LOADED";
export const SCREEN_CREATED = "SCREEN_CREATED";
export const SCREEN_MULTIPLE_CREATED = "SCREEN_MULTIPLE_CREATED";
export const SCREEN_EDITED = "SCREEN_EDITED";
export const SCREEN_DELETED = "SCREEN_DELETED";
export const SCREEN_FAILED = "SCREEN_FAILED";

export const SCREENITEM_LOADING = "SCREENITEM_LOADING";
export const SCREENITEM_LOADED = "SCREENITEM_LOADED";
export const SCREENITEM_CREATED = "SCREENITEM_CREATED";
export const SCREENITEM_MULTIPLE_CREATETD = "SCREENITEM_MULTIPLE_CREATETD";
export const SCREENITEM_EDITED = "SCREENITEM_EDITED";
export const SCREENITEM_DELETED = "SCREENITEM_DELETED";
export const SCREENITEM_FAILED = "SCREENITEM_FAILED";

//SMS
export const SMS_LOADING = "SMS_LOADING";

export const SMS_ROUTES_LOADING = "SMS_ROUTES_LOADING";
export const SMS_ROUTES_LOADED = "SMS_ROUTES_LOADED";
export const SMS_ROUTES_CREATED = "SMS_ROUTES_CREATED";
export const SMS_ROUTES_EDITED = "SMS_ROUTES_EDITED";
export const SMS_ROUTES_DELETED = "SMS_ROUTES_DELETED";
export const SMS_ROUTES_FAILED = "SMS_ROUTES_FAILED";

export const RESUBMISSION_LOADING = "RESUBMISSION_LOADING";
export const RESUBMITTED_LOADED = "RESUBMITTED_LOADED";
export const RESUBMITTED_SEARCH = "RESUBMITTED_SEARCH";
export const RESUBMISSION_QUEUED = "RESUBMISSION_QUEUED";
export const RESUBMISSION_STATS = "RESUBMISSION_STATS";
export const RESUBMITTED_FAILED = "RESUBMITTED_FAILED";

export const SMS_HEADER_LOADING = "SMS_HEADER_LOADING";
export const SMS_HEADER_LOADED = "SMS_HEADER_LOADED";
export const SMS_HEADER_CREATED = "SMS_HEADER_CREATED";
export const SMS_HEADER_EDITED = "SMS_HEADER_EDITED";
export const SMS_HEADER_DELETED = "SMS_HEADER_DELETED";
export const SMS_HEADER_FAILED = "SMS_HEADER_FAILED";

// Service Provider products
export const CPPRODUCT_LOADING = "CPPRODUCT_LOADING";
export const CPPRODUCT_CREATED = "CPPRODUCT_CREATED";
export const CPPRODUCT_DELETED = "CPPRODUCT_DELETED";
export const CPPRODUCT_DETAILS = "CPPRODUCT_DETAILS";
export const CPPRODUCT_LOADED = "CPPRODUCT_LOADED";
export const CPPRODUCT_EDITED = "CPPRODUCT_EDITED";
export const CPPRODUCT_SEARCH = "CPPRODUCT_SEARCH";
export const CPPRODUCT_FAILED = "CPPRODUCT_FAILED";

export const PRODUCTTOKEN_LOADING = "PRODUCTTOKEN_LOADING";
export const PRODUCTTOKEN_DELETED = "PRODUCTTOKEN_DELETED";
export const PRODUCTTOKEN_EDITED = "PRODUCTTOKEN_EDITED";
export const PRODUCTTOKEN_ADDED = "PRODUCTTOKEN_ADDED";
export const PRODUCTTOKEN_FAILED = "PRODUCTTOKEN_FAILED";

export const PRODUCTACCESS_LOADING = "PRODUCTACCESS_LOADING";
export const PRODUCTACCESS_DELETED = "PRODUCTACCESS_DELETED";
export const PRODUCTACCESS_EDITED = "PRODUCTACCESS_EDITED";
export const PRODUCTACCESS_ADDED = "PRODUCTACCESS_ADDED";
export const PRODUCTACCESS_FAILED = "PRODUCTACCESS_FAILED";

export const PRODUCTCONTENT_LOADING = "PRODUCTCONTENT_LOADING";
export const PRODUCTCONTENT_LOADED = "PRODUCTCONTENT_LOADED";
export const PRODUCTCONTENT_SEARCH = "PRODUCTCONTENT_SEARCH";
export const PRODUCTCONFIG_LOADED = "PRODUCTCONFIG_LOADED";
export const PRODUCTCONFIG_FAILED = "PRODUCTCONFIG_FAILED";
export const PRODUCTCONTENT_CREATED = "PRODUCTCONTENT_CREATED";
export const PRODUCTCONTENT_EDITED = "PRODUCTCONTENT_EDITED";
export const PRODUCTCONTENT_DELETED = "PRODUCTCONTENT_DELETED";
export const PRODUCTCONTENT_FAILED = "PRODUCTCONTENT_FAILED";

export const PRODUCTEVENT_LOADING = "PRODUCTEVENT_LOADING";
export const PRODUCTEVENT_LOADED = "PRODUCTEVENT_LOADED";
export const PRODUCTEVENT_CREATED = "PRODUCTEVENT_CREATED";
export const PRODUCTEVENT_EDITED = "PRODUCTEVENT_EDITED";
export const PRODUCTEVENT_DELETED = "PRODUCTEVENT_DELETED";
export const PRODUCTEVENT_FAILED = "PRODUCTEVENT_FAILED";

export const NETWORKPRODUCT_LOADING = "NETWORKPRODUCT_LOADING";
export const NETWORKPRODUCT_LOADED = "NETWORKPRODUCT_LOADED";
export const NETWORKPRODUCT_CREATED = "NETWORKPRODUCT_CREATED";
export const NETWORKPRODUCT_EDITED = "NETWORKPRODUCT_EDITED";
export const NETWORKPRODUCT_DELETED = "NETWORKPRODUCT_DELETED";
export const NETWORKPRODUCT_FAILED = "NETWORKPRODUCT_FAILED";

export const PRODUCTSELECTED = "PRODUCTSELECTED";
export const COMPANYSELECTED = "COMPANYSELECTED";

//Billings
export const BILLINGS_LOADING = "BILLINGS_LOADING";
export const BILLINGS_TRANS_LOADED = "BILLINGS_TRANS_LOADED";
export const BILLINGS_TRANS_EXPORTED = "BILLINGS_TRANS_EXPORTED";
export const BILLINGS_SP_LOADED = "BILLINGS_SP_LOADED";
export const BILLINGS_CREDITTED = "BILLINGS_CREDITTED";
export const BILLINGS_APPROVAL = "BILLINGS_APPROVAL";
export const BILLINGS_FAILED = "BILLINGS_FAILED";

export const SMSOUT_LOADING = "SMSOUT_LOADING";
export const SMSOUT_LOADED = "SMSOUT_LOADED";
export const SMSOUT_SUCCESS = "SMSOUT_SUCCESS";
export const SMSOUT_DETAILS_LOADED = "SMSOUT_DETAILS_LOADED";
export const SMSIN_DETAILS_LOADED = "SMSIN_DETAILS_LOADED";
export const SMSOUT_GROUPED_LOADED = "SMSOUT_GROUPED_LOADED";
export const SMSOUT_NETWORK_SP_TRANS = "SMSOUT_NETWORK_SP_TRANS";
export const SMSOUT_NETWORK_TRANS_LOADED = "SMSOUT_NETWORK_TRANS_LOADED";
export const SMSOUT_NETWORK_SP_TRANS_EXPORTED =
  "SMSOUT_NETWORK_SP_TRANS_EXPORTED";
export const SMSOUT_ALL_NETWORK_TRANS_LOADED =
  "SMSOUT_ALL_NETWORK_TRANS_LOADED";

export const SMSOUT_SUBMITED_LOADED = "SMSOUT_SUBMITED_LOADED";
export const SMSOUT_FAILED = "SMSOUT_FAILED";

export const USSD_REPORT_LOADING = "USSD_REPORT_LOADING";
export const USSD_REPORT_LOADED = "USSD_REPORT_LOADED";
export const USSD_GREPORT_LOADED = "USSD_GREPORT_LOADED";
export const USSD_CODESESSION_REPORT_LOADED = "USSD_CODESESSION_REPORT_LOADED";
export const USSD_CODEPHONE_REPORT_LOADED = "USSD_CODEPHONE_REPORT_LOADED";
export const USSD_REPORT_FAILED = "USSD_REPORT_FAILED";

export const SUBCHARGES_LOADING = "SUBCHARGES_LOADING";
export const SUBCHARGES_LOADED = "SUBCHARGES_LOADED";
export const SUBCHARGES_GROUPED_LOADED = "SUBCHARGES_GROUPED_LOADED";
export const SUBCHARGES_FAILED = "SUBCHARGES_FAILED";

export const REPORT_LOADING = "REPORT_LOADING";
export const REPORT_SUBCHARGE = "REPORT_SUBCHARGE";
export const REPORT_SMSOUT = "REPORT_SMSOUT";
export const REPORT_SMS_SENDERID = "REPORT_SMS_SENDERID";
export const REPORT_SMSIN = "REPORT_SMSIN";
export const REPORT_IVROUT = "REPORT_IVROUT";
export const REPORT_IVRIN = "REPORT_IVRIN";
export const REPORT_FAILED = "REPORT_FAILED";

// Dashboard
export const DASHBOARD_LOADING = "DASHBOARD_LOADING";
export const DASHBOARD_LOADED = "DASHBOARD_LOADED";
export const DASHBOARD_FAILED = "DASHBOARD_FAILED";

export const TODAY_ACTIVITIES_LOADING = "TODAY_ACTIVITIES_LOADING";
export const TODAY_ACTIVITIES_LOADED = "TODAY_ACTIVITIES_LOADED";
export const TODAY_ACTIVITIES_FAILED = "TODAY_ACTIVITIES_FAILED";

export const COMMANDLOG_LOADING = "COMMANDLOG_LOADING";
export const COMMANDLOG_LOADED = "COMMANDLOG_LOADED";
export const COMMANDLOG_FAILED = "COMMANDLOG_FAILED";

export const CHARGE_LOADING = "CHARGE_LOADING";
export const CHARGE_LOADED = "CHARGE_LOADED";
export const CHARGE_CREATED = "CHARGE_CREATED";
export const CHARGE_EDITED = "CHARGE_EDITED";
export const CHARGE_DELETED = "CHARGE_DELETED";
export const CHARGE_SEARCH = "CHARGE_SEARCH";
export const CHARGE_FAILED = "CHARGE_FAILED";

export const MNOFEE_LOADING = "MNOFEE_LOADING";
export const MNOFEE_LOADED = "MNOFEE_LOADED";
export const MNOFEE_CREATED = "MNOFEE_CREATED";
export const MNOFEE_EDITED = "MNOFEE_EDITED";
export const MNOFEE_DELETED = "MNOFEE_DELETED";
export const MNOFEE_FAILED = "MNOFEE_FAILED";

export const STATUS_LOADING = "STATUS_LOADING";
export const STATUS_SMSOUT_LOADED = "STATUS_SMSOUT_LOADED";
export const STATUS_SMSIN_LOADED = "STATUS_SMSIN_LOADED";
export const STATUS_IVROUT_LOADED = "STATUS_IVROUT_LOADED";
export const STATUS_IVRIN_LOADED = "STATUS_IVRIN_LOADED";
export const STATUS_FAILED = "STATUS_FAILED";

export const PRIVILEDGE_LOADING = "PRIVILEDGE_LOADING";
export const RESOURCES_LOADED = "RESOURCES_LOADED";
export const PRIVILEDGE_LOADED = "PRIVILEDGE_LOADED";
export const PRIVILEDGE_DETAILS = "PRIVILEDGE_DETAILS";
export const PRIVILEDGE_EDITED = "PRIVILEDGE_EDITED";
export const PRIVILEDGE_CREATED = "PRIVILEDGE_CREATED";
export const PRIVILEDGE_DELETED = "PRIVILEDGE_DELETED";
export const PRIVILEDGE_FAILED = "PRIVILEDGE_FAILED";

export const PERMISSION_ADDED = "PERMISSION_ADDED";
export const PERMISSION_REMOVED = "PERMISSION_REMOVED";

export const RESET_STATUS = "RESET_STATUS";
export const RESET_MESSAGE = "RESET_MESSAGE";

export const ROUTEPATHCHANGE = "ROUTEPATHCHANGE";

export const USERS_LOADING = "USERS_LOADING";
export const USERS_LOADED = "USERS_LOADED";
export const USERS_SEARCH = "USERS_SEARCH";
export const USERS_CREATED = "USERS_CREATED";
export const USERS_DELETED = "USERS_DELETED";
export const USERS_EDITED = "USERS_EDITED";
export const USERS_FAILED = "USERS_FAILED";

export const USERS_ACTIVITIES_LOADING = "USERS_ACTIVITIES_LOADING";
export const USERS_ACTIVITIES_LOADED = "USERS_ACTIVITIES_LOADED";
export const USERS_ACTIVITIES_FAILED = "USERS_ACTIVITIES_FAILED";

export const SMSURI_LOADING = "SMSURI_LOADING";
export const SMSURI_LOADED = "SMSURI_LOADED";
export const SMSURI_EDITED = "SMSURI_EDITED";
export const SMSURI_SEARCH = "SMSURI_SEARCH";
export const SMSURI_DELETED = "SMSURI_DELETED";
export const SMSURI_FAILED = "SMSURI_FAILED";
export const SMSURI_CREATED = "SMSURI_CREATED";

export const PREFIXROUTE_LOADING = "PREFIXROUTE_LOADING";
export const PREFIXROUTE_LOADED = "PREFIXROUTE_LOADED";
export const PREFIXROUTE_FAILED = "PREFIXROUTE_FAILED";
export const PREFIXROUTE_DELETED = "PREFIXROUTE_DELETED";
export const PREFIXROUTE_EDITED = "PREFIXROUTE_EDITED";
export const PREFIXROUTE_CREATETD = "PREFIXROUTE_CREATETD";

export const PREFIXROUTEGROUP_LOADING = "PREFIXROUTEGROUP_LOADING";
export const PREFIXROUTEGROUP_LOADED = "PREFIXROUTEGROUP_LOADED";
export const PREFIXROUTEGROUP_FAILED = "PREFIXROUTEGROUP_FAILED";
export const PREFIXROUTEGROUP_DELETED = "PREFIXROUTEGROUP_DELETED";
export const PREFIXROUTEGROUP_EDITED = "PREFIXROUTEGROUP_EDITED";
export const PREFIXROUTEGROUP_CREATETD = "PREFIXROUTEGROUP_CREATETD";

export const PIPEGROUP_LOADING = "PIPEGROUP_LOADING";
export const PIPEGROUP_LOADED = "PIPEGROUP_LOADED";
export const PIPEGROUP_FAILED = "PIPEGROUP_FAILED";
export const PIPEGROUP_DELETED = "PIPEGROUP_DELETED";
export const PIPEGROUP_EDITED = "PIPEGROUP_EDITED";
export const PIPEGROUP_CREATETD = "PIPEGROUP_CREATETD";

export const DOMAIN_LOADING = "DOMAIN_LOADING";
export const DOMAIN_LOADED = "DOMAIN_LOADED";
export const DOMAIN_FAILED = "DOMAIN_FAILED";
export const DOMAIN_DELETED = "DOMAIN_DELETED";
export const DOMAIN_EDITED = "DOMAIN_EDITED";
export const DOMAIN_CREATETD = "DOMAIN_CREATETD";

export const ALPHATAG_LOADING = "ALPHATAG_LOADING";
export const ALPHATAG_LOADED = "ALPHATAG_LOADED";
export const ALPHATAG_FAILED = "ALPHATAG_FAILED";
export const ALPHATAG_DELETED = "ALPHATAG_DELETED";
export const ALPHATAG_EDITED = "ALPHATAG_EDITED";
export const ALPHATAG_CREATED = "ALPHATAG_CREATED";
export const ALPHATAG_SEARCH = "ALPHATAG_SEARCH";
export const ALPHATAG_SEARCHRESET = "ALPHATAG_SEARCHRESET";

export const ALPHATAG_ALLOCATED = "ALPHATAG_ALLOCATED";
export const ALPHATAG_DEALLOCATED = "ALPHATAG_DEALLOCATED";
export const ALPHATAG_COMPANY_LOADED = "ALPHATAG_COMPANY_LOADED";
export const ALPHATAG_COMPANY_SEARCH = "ALPHATAG_COMPANY_SEARCH";

export const PROXUSER_LOADING = "PROXUSER_LOADING";
export const PROXUSER_LOADED = "PROXUSER_LOADED";
export const PROXUSER_FAILED = "PROXUSER_FAILED";
export const PROXUSER_EDITED = "PROXUSER_EDITED";
export const PROXUSER_DELETED = "PROXUSER_DELETED";
export const PROXUSER_CREATED = "PROXUSER_CREATED";

export const PROXLOGS_LOADING = "PROXLOGS_LOADING";
export const PROXLOGS_LOADED = "PROXLOGS_LOADED";
export const PROXLOGS_FAILED = "PROXLOGS_FAILED";

export const APIKEY_LOADING = "APIKEY_LOADING";
export const APIKEY_LOADED = "APIKEY_LOADED";
export const APIKEY_FAILED = "APIKEY_FAILED";
export const APIKEY_GENERATED = "APIKEY_GENERATED";

export const SYSTEMLOGS_LOADING = "SYSTEMLOGS_LOADING";
export const SYSTEMLOGS_LOADED = "SYSTEMLOGS_LOADED";
export const SYSTEMLOGS_FAILED = "SYSTEMLOGS_FAILED";

export const SMSPUSH_LOADING = "SMSPUSH_LOADING";
export const SMSPUSH_SUCCESS = "SMSPUSH_SUCCESS";
export const SMSPUSH_DETAILS_SUCCESS = "SMSPUSH_DETAILS_SUCCESS";
export const SMSPUSH_RESET = "SMSPUSH_RESET ";
export const SMSPUSH_SUMMARY = "SMSPUSH_SUMMARY";
export const SMSPUSH_FAILED = "SMSPUSH_FAILED";

export const WALLET_LOADING = "WALLET_LOADING";
export const WALLET_ACCOUNT_LOADED = "WALLET_ACCOUNT_LOADED";
export const WALLET_ACCOUNT_SEARCHED = "WALLET_ACCOUNT_SEARCHED ";
export const WALLET_TRANSACTION_LOADED = "WALLET_TRANSACTION_LOADED";
export const WALLET_FAILED = "WALLET_FAILED";

export const USSD_GROUPED_LOADED = "USSD_GROUPED_LOADED";
export const USSD_DETAILED_LOADED = "USSD_DETAILED_LOADED";
export const USSD_FAILED = "USSD_FAILED";

export const VAS_LOADING = "VAS_LOADING";
export const TWREQUESTS_LOADED = "TWREQUESTS_LOADED";
export const SUBREQUEST_LOADED = "SUBREQUEST_LOADED";
export const SUBREQUEST_EXPORT = "SUBREQUEST_EXPORT";
export const WHLOGS_LOADED = "WHLOGS_LOADED";
export const TWREQUESTS_GROUP_LOADED = "TWREQUESTS_GROUP_LOADED";
export const SUBREQUEST_GROUP_LOADED = "SUBREQUEST_GROUP_LOADED";
export const SUB_HISTORY_LOAD = "SUB_HISTORY_LOAD";
export const WHLOGS_GROUP_LOADED = "WHLOGS_GROUP_LOADED";
export const WHLOGS_SUCCESS = "WHLOGS_SUCCESS";
export const VAS_FAILED = "VAS_FAILED";

export const REGISTERED_NUMBER_LOADING = "REGISTERED_NUMBER_LOADING";
export const REGISTERED_NUMBER_DELETED = "REGISTERED_NUMBER_DELETED";
export const REGISTERED_NUMBER_CREATED = "REGISTERED_NUMBER_CREATED";
export const REGISTERED_NUMBER_LOADED = "REGISTERED_NUMBER_LOADED";
export const REGISTERED_NUMBER_SEARCH = "REGISTERED_NUMBER_SEARCH";
export const REGISTERED_NUMBER_EDITED = "REGISTERED_NUMBER_EDITED";
export const REGISTERED_NUMBER_FAILED = "REGISTERED_NUMBER_FAILED";

export const VOICE_PRODUCT_LOADING = "VOICE_PRODUCT_LOADING";
export const VOICE_PRODUCT_LOADED = "VOICE_PRODUCT_LOADED";
export const VOICE_PRODUCT_SEARCH = "VOICE_PRODUCT_SEARCH";
export const VOICE_PRODUCT_CREATED = "VOICE_PRODUCT_CREATED";
export const VOICE_PRODUCT_EDITED = "VOICE_PRODUCT_EDITED";
export const VOICE_PRODUCT_DELETED = "VOICE_PRODUCT_DELETED";
export const VOICE_PRODUCT_FAILED = "VOICE_PRODUCT_FAILED";

export const VOICE_CONTENT_LOADING = "VOICE_CONTENT_LOADING";
export const VOICE_CONTENT_LOADED = "VOICE_CONTENT_LOADED";
export const VOICE_CONTENT_SEARCH = "VOICE_CONTENT_SEARCH";
export const VOICE_CONTENT_CREATED = "VOICE_CONTENT_CREATED";
export const VOICE_CONTENT_EDITED = "VOICE_CONTENT_EDITED";
export const VOICE_CONTENT_DELETED = "VOICE_CONTENT_DELETED";
export const VOICE_CONTENT_FAILED = "VOICE_CONTENT_FAILED";

export const COMPANY_NUMBER_LOADING = "COMPANY_NUMBER_LOADING";
export const COMPANY_NUMBER_DELETED = "COMPANY_NUMBER_DELETED";
export const COMPANY_NUMBER_CREATED = "COMPANY_NUMBER_CREATED";
export const COMPANY_NUMBER_EDITED = "COMPANY_NUMBER_EDITED";
export const COMPANY_NUMBER_LOADED = "COMPANY_NUMBER_LOADED";
export const COMPANY_NUMBER_SEARCH = "COMPANY_NUMBER_SEARCH";
export const COMPANY_NUMBER_GOT = "COMPANY_NUMBER_GOT";
export const COMPANY_NUMBER_FAILED = "COMPANY_NUMBER_FAILED";

export const VOICE_LOG_LOADING = "VOICE_LOG_LOADING";
export const VOICE_LOG_LOADED = "VOICE_LOG_LOADED";
export const VOICE_LOG_FAILED = "VOICE_LOG_FAILED";

export const VOICE_EVENTS_LOADING = "VOICE_EVENTS_LOADING";
export const VOICE_EVENTS_LOADED = "VOICE_EVENTS_LOADED";
export const VOICE_EVENTS_FAILED = "VOICE_EVENTS_FAILED";

export const CP_LOADING = "CP_LOADING";

export const CP_LOADED = "CP_LOADED";
export const CP_SEARCH = "CP_SEARCH";
export const CP_EDITED = "CP_EDITED";

export const CP_PROXUSER_LOADED = "CP_PROXUSER_LOADED";
export const CP_PROXUSER_DELETED = "CP_PROXUSER_DELETED";
export const CP_PROXUSER_CREATED = "CP_PROXUSER_CREATED";
export const CP_PROXUSER_EDITED = "CP_PROXUSER_EDITED";

export const CP_FUND_HISTORY = "CP_FUND_HISTORY";
export const CP_FUND_INITATE = "CP_FUND_INITATE";
export const CP_FUND_COMPLETED = "CP_FUND_COMPLETED";

export const CP_FAILED = "CP_FAILED";

export const ADDRBOOK_LOADING = "ADDRBOOK_LOADING";
export const ADDRBOOK_CREATED = "ADDRBOOK_CREATED";
export const ADDRBOOK_EDITED = "ADDRBOOK_EDITED";
export const ADDRBOOK_DELETE = "ADDRBOOK_DELETE";
export const ADDRBOOK_LOADED = "ADDRBOOK_LOADED";
export const ADDRBOOK_SEARCH = "ADDRBOOK_SEARCH";
export const ADDRBOOK_DEFAULT = "ADDRBOOK_DEFAULT";
export const ADDRBOOK_FAILED = "ADDRBOOK_FAILED";

export const ADDRPHONE_SEARCH = "ADDRPHONE_SEARCH";
export const ADDRPHONE_LOADED = "ADDRPHONE_LOADED";
export const ADDRPHONE_CREATED = "ADDRPHONE_CREATED";
export const ADDRPHONE_DELETE = "ADDRPHONE_DELETE";
export const ADDRPHONE_EDIT = "ADDRPHONE_EDIT";

export const CAMPAIGN_LOADED = "CAMPAIGN_LOADED";
export const CAMPAIGN_SEARCH = "CAMPAIGN_SEARCH";
export const CAMPAIGN_CREATED = "CAMPAIGN_CREATED";
export const CAMPAIGN_DELETE = "CAMPAIGN_DELETE";
export const CAMPAIGN_EDIT = "CAMPAIGN_EDIT";

export const SP_NOTIFIER_LOADING = "SP_NOTIFIER_LOADING";
export const SP_NOTIFIER_LOADED = "SP_NOTIFIER_LOADED";
export const SP_NOTIFIER_CREATED = "SP_NOTIFIER_CREATED";
export const SP_NOTIFIER_EDITED = "SP_NOTIFIER_EDITED";
export const SP_NOTIFIER_DELETED = "SP_NOTIFIER_DELETED";
export const SP_NOTIFIER_FAILED = "SP_NOTIFIER_FAILED";

export const COMPANY_USER_LOADED = "COMPANY_USER_LOADED";
export const COMPANY_USER_EDITED = "COMPANY_USER_EDITED";
export const COMPANY_USER_FAILED = "COMPANY_USER_FAILED";
export const COMPANY_USER_ADDED = "COMPANY_USER_ADDED";

export const BASE_URL = "localhost:8080";
